import { ApolloClient, ApolloLink, createHttpLink, InMemoryCache } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';

import { getSessionToken } from '@/helpers';
import { authErrorLink } from './auth-error-link';

const httpLink = createHttpLink({ uri: import.meta.env.VITE_SNAPPEA_GRAPHQL_URI });

const authLink = setContext((_, { headers }) => {
  const token = getSessionToken();
  return {
    headers: {
      ...headers,
      'X-ClientToken': import.meta.env.VITE_SNAPPEA_API_CLIENT_TOKEN,
      ...(token ? { 'X-SessionToken': token } : {}),
    },
  };
});

const client = new ApolloClient({
  link: ApolloLink.from([authErrorLink, authLink, httpLink]),
  cache: new InMemoryCache({
    typePolicies: {
      VendorAvailabilityListItem: {
        keyFields: ['vendorId', 'productType'],
      },
    },
  }),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'all',
    },
    query: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'all',
    },
  },
});

export default client;
